import { computed, observable } from 'mobx';
import { IImage, IChildLayout } from '~/types/model.types';
import {
    IContainerBlockResponse,
    IContainerableBlockResponse,
    ICompanyInfoBlockResponse,
    ILeadDetailsBlockResponse
} from '~/types/server.types';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { ContainerBlock } from '~/models/blocks/container-block.model';
import type { ContainerableBlock } from '~/models/blocks/containerable-block.model';
import { CXContainerableBlock } from '~/components/ClientExperience/OneFlow/models/cx-containerable-block.model';
import {
    ContentWidth,
    IContainerBlockStyles
} from '~/types/block-styles.types';
import type { FlowRevision } from '~/models/flow-revision.model';

export class CXContainerBlock extends CXContainerableBlock {
    type: 'container_block' | 'company_info_block' | 'lead_details_block';
    @observable background_image: IImage;
    @observable styles: IContainerBlockStyles;

    constructor(
        block:
            | ContainerBlock
            | ICompanyInfoBlockResponse
            | IContainerBlockResponse
            | ILeadDetailsBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(
            block as IContainerableBlockResponse | ContainerableBlock,
            flowRevision,
            rootStore
        );
        this.type = block.type;

        if (block instanceof ContainerBlock) {
            this.children = (<ContainerBlock>block).children;
        } else {
            this.children = block.children as IChildLayout[];
        }

        this.children = this.children || [];
    }

    @computed
    get isFullWidthContent() {
        return this.styles.content_width === ContentWidth.FULL;
    }

    isBackgroundImagePlaceholder() {
        return this.background_image && !this.background_image.url;
    }

    @computed
    get columnSizePercentage() {
        const numberOfSiblings = this.parent.children.length;
        if (numberOfSiblings === 1) {
            return 100;
        }

        const verticalContainerSize = this.parent.children.find(
            child => child.block_id === this.block_id
        ).size;

        // column size can be minimum of 10 percent.
        // if it's less (can happen in legacy flows) - give it the equal share between siblings
        return verticalContainerSize < 10
            ? 100 / numberOfSiblings
            : verticalContainerSize;
    }
}
